import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <SEO
        title="Kebijakan Privasi"
        description="Kebijakan privasi KasirWA menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi data pengguna."
        path="/privacy"
      />
      <header className="bg-white border-b border-slate-100 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#0f6c44] rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-sm">K</span>
            </div>
            <span className="font-bold text-slate-800">KasirWA</span>
          </Link>
          <Link to="/" className="text-sm text-[#0f6c44] hover:underline">Kembali ke Beranda</Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Kebijakan Privasi</h1>
        <p className="text-slate-500 text-sm mb-8">Terakhir diperbarui: Januari 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-700">
          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">1. Informasi yang Kami Kumpulkan</h2>
            <p>KasirWA mengumpulkan informasi yang Anda berikan secara langsung saat mendaftar dan menggunakan layanan kami, termasuk:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li>Nama, alamat email, dan nomor WhatsApp</li>
              <li>Informasi toko (nama, alamat, tipe bisnis)</li>
              <li>Data transaksi dan pesanan bisnis Anda</li>
              <li>Data pelanggan yang Anda masukkan ke dalam sistem</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">2. Penggunaan Informasi</h2>
            <p>Kami menggunakan informasi yang dikumpulkan untuk:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
              <li>Menyediakan dan meningkatkan layanan KasirWA</li>
              <li>Mengirimkan notifikasi WhatsApp atas nama toko Anda</li>
              <li>Menghasilkan laporan keuangan dan bisnis</li>
              <li>Menghubungi Anda terkait pembaruan layanan</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">3. Keamanan Data</h2>
            <p className="text-sm">Kami menggunakan enkripsi SSL/TLS untuk melindungi data dalam transit. Password disimpan menggunakan algoritma hashing bcrypt. Data disimpan di server yang aman dan tidak dibagikan kepada pihak ketiga tanpa persetujuan Anda.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">4. Data Pelanggan Toko Anda</h2>
            <p className="text-sm">Data pelanggan yang Anda masukkan (nama, nomor HP, riwayat pesanan) adalah milik Anda sepenuhnya. KasirWA tidak menggunakan data pelanggan Anda untuk tujuan komersial lainnya.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">5. Integrasi WhatsApp (Fonnte)</h2>
            <p className="text-sm">KasirWA menggunakan layanan Fonnte API untuk pengiriman pesan WhatsApp. Nomor HP pelanggan Anda dikirimkan ke Fonnte hanya untuk keperluan pengiriman notifikasi. Kami menyarankan Anda membaca <a href="https://fonnte.com/privacy-policy" target="_blank" rel="noreferrer" className="text-[#0f6c44] underline">kebijakan privasi Fonnte</a>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">6. Hak Pengguna</h2>
            <p className="text-sm">Anda berhak untuk mengakses, memperbaiki, atau menghapus data Anda kapan saja. Untuk permintaan penghapusan akun, hubungi kami di support@kasirwa.com.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">7. Perubahan Kebijakan</h2>
            <p className="text-sm">Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Perubahan signifikan akan diberitahukan melalui email atau notifikasi dalam aplikasi.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-800 mb-3">8. Hubungi Kami</h2>
            <p className="text-sm">Pertanyaan tentang kebijakan privasi dapat dikirimkan ke: <a href="mailto:support@kasirwa.com" className="text-[#0f6c44] underline">support@kasirwa.com</a></p>
          </section>
        </div>
      </main>

      <footer className="border-t border-slate-200 mt-16 py-8 text-center text-sm text-slate-400">
        <p>&copy; {new Date().getFullYear()} KasirWA. Semua hak dilindungi.</p>
        <div className="flex justify-center gap-4 mt-2">
          <Link to="/privacy" className="hover:text-[#0f6c44]">Privasi</Link>
          <Link to="/terms" className="hover:text-[#0f6c44]">Syarat</Link>
          <Link to="/about" className="hover:text-[#0f6c44]">Tentang</Link>
        </div>
      </footer>
    </div>
  );
}
